/* eslint-disable */
import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import { Checkbox, RadioButton, DateField } from '../../../commons/Inputs';
import appConfig from '../../../../config';
import axios from 'axios';

export default class MedicalHistory extends Component {

	state = {

		displayHealthChanges : 'none',
		displayHospitalized : 'none',
		medicalRender : true,

		physician_name : '',
		specialty : '',
		office_address : '',
		referred_by : '',
		referred_date : '',
		allergies : '',
		allergy_medication : '',
		health_changes : '',
		health_changes_question : '',
		hospitalized : '',
		hospitalized_question : '',
		aspirin : '',
		anticoagulants : '',
		heart_medication : '',
		antibiotics : '',
		steroids : '',
		diabetes : '',
		narcotics : '',
		tranquilizers : '',
		birth_control : '',
		recreational : '',
		sickness : [],
		family_sickness : [],
		smoking : '',
		patient_other_sickness : '',
		patientId : 0,

		checkboxItem : [
			{name : 'questionnaires[sickness][rheumatic]',label : 'Rheumatic Fever', id : 'medbox' , value : 'rheumatic'},
			{name : 'questionnaires[sickness][stroke]',label : 'Stroke', id : 'medbox' , value : 'stroke'},
			{name : 'questionnaires[sickness][asthma]',label : 'Asthma', id : 'medbox' , value : 'asthma'},
			{name : 'questionnaires[sickness][jaundice]',label : 'Jaundice', id : 'medbox' , value : 'jaundice'},
			{name : 'questionnaires[sickness][anemia]',label : 'Anemia', id : 'medbox' , value : 'anemia'},
			{name : 'questionnaires[sickness][arthritis]',label : 'Arthritis', id : 'medbox' , value : 'arthritis'},
			{name : 'questionnaires[sickness][epilepsy]',label : 'Epilepsy', id : 'medbox' , value : 'epilepsy'},
			{name : 'questionnaires[sickness][thyroid]',label : 'Thyroid', id : 'medbox' , value : 'thyroid'},
			{name : 'questionnaires[sickness][tonsilitis]',label : 'Tonsilitis', id : 'medbox' , value : 'tonsilitis'},
			{name : 'questionnaires[sickness][rhd]',label : 'Rheumatic Heart Disease', id : 'medbox' , value : 'rhd'},
			{name : 'questionnaires[sickness][hbp]',label : 'High Blood Pressure', id : 'medbox' , value : 'hbp'},
			{name : 'questionnaires[sickness][hormonal_disorder]',label : 'Hormonal Disorder', id : 'medbox' , value : 'hormonal_disorder'},
			{name : 'questionnaires[sickness][hepatitis]',label : 'Hepatitis', id : 'medbox' , value : 'hepatitis'},
			{name : 'questionnaires[sickness][herpes]',label : 'Herpes', id : 'medbox' , value : 'herpes'},
			{name : 'questionnaires[sickness][AIDS]',label : 'AIDS', id : 'medbox' , value : 'AIDS'},
			{name : 'questionnaires[sickness][stomach_ulcer]',label : 'Stomach Ulcer', id : 'medbox' , value : 'stomach_ulcer'},
			{name : 'questionnaires[sickness][kidney_disease]',label : 'Kidney Disease', id : 'medbox' , value : 'kidney_disease'},
			{name : 'questionnaires[sickness][neurological_problems]',label : 'Neurological Problems', id : 'medbox' , value : 'neurological_problems'},
			{name : 'questionnaires[sickness][malignancies]',label : 'Malignancies', id : 'medbox' , value : 'malignancies'},
			{name : 'questionnaires[sickness][prostate_problems]',label : 'Prostate problems', id : 'medbox' , value : 'prostate_problems'},
			{name : 'questionnaires[sickness][any_heart_ailments]',label : 'Any Heart Ailments', id : 'medbox' , value : 'any_heart_ailments'},
			{name : 'questionnaires[sickness][heart_murmur]',label : 'Heart Murmur', id : 'medbox' , value : 'heart_murmur'},
			{name : 'questionnaires[sickness][diabetes]',label : 'Diabetes', id : 'medbox' , value : 'diabetes'},
			{name : 'questionnaires[sickness][tubercolosis]',label : 'Tubercolosis', id : 'medbox' , value : 'tubercolosis'},
			{name : 'questionnaires[sickness][venereal_disease]',label : 'Venereal Disease', id : 'medbox' , value : 'venereal_disease'},
			{name : 'questionnaires[sickness][blood_disorders]',label : 'Blood Disorders', id : 'medbox' , value : 'blood_disorders'},
			{name : 'questionnaires[sickness][bleeding_problems]',label : 'Bleeding Problems', id : 'medbox' , value : 'bleeding_problems'},
			{name : 'questionnaires[sickness][sinus_problems]',label : 'Sinus Problems', id : 'medbox' , value : 'sinus_problems'},
			{name : 'questionnaires[sickness][radiation_treatment]',label : 'Radiation Treatment', id : 'medbox' , value : 'radiation_treatment'},
			{name : 'questionnaires[sickness][eye_disorders]',label : 'Eye Disorders', id : 'medbox' , value : 'eye_disorders'},
			{name : 'questionnaires[sickness][eating_disorders]',label : 'Eating Disorders', id : 'medbox' , value : 'eating_disorders'},
			{name : 'questionnaires[sickness][TMJ]',label : 'TMJ (jaw joint) Problems', id : 'medbox' , value : 'TMJ'}
		],

		checkboxItem2 : [
			{name : 'questionnaires[family_sickness][bleeding_problems]', label : 'Bleeding Problems', id : 'diseaseBox', value : 'bleeding_problems'},
			{name : 'questionnaires[family_sickness][heart_disease]', label : 'Heart Disease', id : 'diseaseBox', value : 'heart_disease'},
			{name : 'questionnaires[family_sickness][anesthetic_complications]', label : 'Anesthetic Complications (problems going to sleep for an operation)', id : 'diseaseBox', value : 'anesthetic_complications'}
		]
	};

	showSuccessNotification = () => {
        // let notificationSystem = this.refs.notificationSystem;
        
        // notificationSystem.addNotification({
        //     title: 'Saved! Successfully',
        //     message: 'Medical history Successfully Saved!',
        //     level: 'success',
        //     position : 'br',
        //     autoDismiss : 1
        // });

        App.alert({
        	type: 'info',
        	container : $('#alertNotif'),
        	message: 'Saved! Succesfully!',
        	reset: true,
        	focus: false,
        	close: false,	
        	closeInSeconds: 1})
    };

    onShowQuestion = (e, stateName) => {

    	if(e.target.value === 'yes')
    	{
    		if(stateName === 'health_changes')
    		{
    			this.setState({displayHealthChanges : 'block'});	
    		}
    		
    		if(stateName === 'hospitalized')
    		{
    			this.setState({displayHospitalized : 'block'});
    		}
    	}else
    	{
    		if(stateName === 'health_changes')
    		{
    			this.setState({displayHealthChanges : 'none'});	
    		}

    		if(stateName === 'hospitalized')
    		{
    			this.setState({displayHospitalized : 'none'});
    		}
    		
    	}
    	
    	this.onInputField(e, stateName);
    }

	onInputField = (e, stateName) => {

		if(typeof stateName !== 'undefined') // change value of state for radio button
		{
			let data = {};
			data[stateName] = e.target.value;

			this.setState(data);
		}

		if($(e.target).val().trim() === '')
		{
			return;
		}

		let formData = $('#medicalHistoryForm').serialize();

			formData += '&patient_id=' + this.state.patientId;
	
		const url = appConfig.apiUrl + 'dental/past-medical-histories/' + this.state.patientId;

        axios({
            url: url,
            method: 'post',
            responseType: 'json',
            data : formData,
        }).then((response) => {
            
            this.showSuccessNotification();
            
        }).catch(function (error) {

        });
	};

	onDatepickerChange = () => {

		// autosave for datepicker
		$('.datepicker').on('hide.daterangepicker', (ev,picker) => {
			this.onInputField(ev);
		});
	};

	getMedicalHistory = () => {

		App.blockUI({
            target: 'body',
            boxed: true
        });

		const url = appConfig.apiUrl + 'dental/past-medical-histories/' + this.state.patientId;

		axios({
            url: url,
            method: 'get',
            responseType: 'json'
        }).then((response) => {
            // console.log(response.data)
            
            let sicknessArray = {};
            if(typeof response.data.data.questionnaires.sickness !== 'undefined')
            {
            	sicknessArray = response.data.data.questionnaires.sickness
            }


            this.setState({
            	physician_name : response.data.data.physician_name,
            	specialty : response.data.data.specialty,
            	office_address : response.data.data.office_address,
            	referred_by : response.data.data.referred_by,
            	referred_date : response.data.data.referred_date,
            	allergies : response.data.data.questionnaires.allergies.length > 0 ? response.data.data.questionnaires.allergies[0] : '',
            	allergy_medication : response.data.data.questionnaires.allergy_medication[0],
            	health_changes : response.data.data.questionnaires.health_changes.choices,
            	health_changes_question : response.data.data.questionnaires.health_changes.question,
            	hospitalized : response.data.data.questionnaires.hospitalized.choices,
            	hospitalized_question : response.data.data.questionnaires.hospitalized.question,
            	aspirin : response.data.data.questionnaires.aspirin ? response.data.data.questionnaires.aspirin : '',
            	anticoagulants : response.data.data.questionnaires.anticoagulants ? response.data.data.questionnaires.anticoagulants : '',
            	heart_medication : response.data.data.questionnaires.heart_medication ? response.data.data.questionnaires.heart_medication : '',
            	antibiotics : response.data.data.questionnaires.antibiotics ? response.data.data.questionnaires.antibiotics : '',
            	steroids : response.data.data.questionnaires.steroids,
            	diabetes : response.data.data.questionnaires.diabetes ? response.data.data.questionnaires.diabetes : '', 
            	narcotics : response.data.data.questionnaires.narcotics,
            	tranquilizers : response.data.data.questionnaires.tranquilizers,
            	birth_control : response.data.data.questionnaires.birth_control ? response.data.data.questionnaires.birth_control : '',
            	recreational : response.data.data.questionnaires.recreational,
            	sickness : sicknessArray,
            	family_sickness : response.data.data.questionnaires.family_sickness ? response.data.data.questionnaires.family_sickness : [],
            	smoking : response.data.data.questionnaires.smoking ? response.data.data.questionnaires.smoking : '',
            	patient_other_sickness : response.data.data.questionnaires.patient_other_sickness,
            	medicalRender : false
            },() => {

            	if(this.state.health_changes === 'yes')
				{
					this.setState({displayHealthChanges : 'block'});
				}else{
					this.setState({displayHealthChanges : 'none'});
				}

				if(this.state.hospitalized === 'yes')
				{
					this.setState({displayHospitalized : 'block'});
				}else{
					this.setState({displayHospitalized : 'none'});
				}

            });
            
            App.unblockUI('body');
           
        }).catch((error) => {
        	console.log(error);
        	this.setState({medicalRender : false});
			App.unblockUI('body');
        });
	};

	radioSelected = (val) => {

	};

	componentWillMount() {

		this.setState({patientId : this.props.storeParams.patientId});
		
	}

	componentDidMount() {
		this.onDatepickerChange();

		// if(sessionStorage.getItem('lastTab') == 'medicalHistoryPage') // last tab open
		// {
		// 	this.getMedicalHistory();
		// }

		$('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {

            let target = e.target.href.split('#');
            let index = target.findIndex((item) => {
                return item === 'medicalHistoryPage'
            });

            if (index >= 0 && this.state.medicalRender) {
                this.getMedicalHistory();
            }
        });
	}

	render() {


		return (
			<form role="form" id="medicalHistoryForm">

				<NotificationSystem ref="notificationSystem" />

				<div className="form-group">
					<div className="row">
						<div className="col-md-6">
							<div className="form-group form-md-line-input">
				                <input type="text" placeholder="" name="physician_name" className="form-control" value={this.state.physician_name} onBlur={this.onInputField}  onChange={(e) => { this.setState({physician_name : e.target.value}) }}/>
								<label className="control-label">Name of Physician</label>
			                </div>
						</div>
						<div className="col-md-6">
							<div className="form-group form-md-line-input">
				                <input type="text" placeholder="" name="specialty" className="form-control" value={this.state.specialty} onBlur={this.onInputField}  onChange={(e) => { this.setState({specialty : e.target.value}) }}/>
								<label className="control-label">Specialty if applicable</label>
			                </div>
						</div>
					</div>
				</div>
				<div className="form-group">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group form-md-line-input">
				                <textarea rows="3" name="office_address" className="form-control" value={this.state.office_address} onBlur={this.onInputField} onChange={(e) => { this.setState({office_address : e.target.value}) }} />
								<label className="control-label">Office Address</label>
			                </div>
						</div>
					</div>
				</div>
				<div className="form-group">
					<div className="row">
						<div className="col-md-12">
							<span>
								There are many situations which can affect or be affected by the procedures or drugs used for oral surgery. Therefore, please fill out the following carefully. Thank you.
							</span>
						</div>
					</div>
				</div>
				<div className="form-group">
					<div className="row">
						<div className="col-md-6">
							<div className="form-group form-md-line-input">
				                <input type="text" placeholder="" name="referred_by" className="form-control" value={this.state.referred_by} onBlur={this.onInputField}  onChange={(e) => { this.setState({referred_by : e.target.value}) }}/>
								<label className="control-label">Referred to this office by</label>
			                </div>
						</div>
						<div className="col-md-6">
							<DateField val={this.state.referred_date} readonly={true} id="referred_date" label="Date of last Medical Exam" help="Enter Date" onChange={(e) => { this.setState({referred_date : e.target.value}) }} />
							
						</div>
					</div>
				</div>
				<div className="form-group">
					<div className="row">
						<div className="col-md-12">
							<ol type="1">
								<li>
									&nbsp;
									<ul style={{listStyleType: 'none'}}>
										<li>
											<div className="form-group form-md-line-input">
								                <input type="text" placeholder="" name="questionnaires[allergies][]" className="form-control" value={this.state.allergies} onBlur={this.onInputField} onChange={(e) => { this.setState({allergies : e.target.value}) }}/>
												<label className="control-label" style={{whiteSpace: 'nowrap',overflow: 'hidden',textOverflow: 'ellipsis'}}>Please list any allergies or sensitivity to any medications or injections.</label>
							                </div>
						                </li>
						                <li>
											<div className="form-group form-md-line-input">
								                <input type="text" placeholder="" name="questionnaires[allergy_medication][]" className="form-control" value={this.state.allergy_medication} onBlur={this.onInputField}  onChange={(e) => { this.setState({allergy_medication : e.target.value}) }}/>
												<label className="control-label">What medications are you taking?</label>
							                </div>
						                </li>
					                </ul>
								</li>
								<li>
									<p>
				                        Has there been any change in you health in the last six months?
				                    </p>
			                        <div className="md-radio-inline" style={{marginBottom: '20px'}}>

			                        	<RadioButton name="questionnaires[health_changes][choices]" id="healthRadio" label="No" index="0" value="no" selectedState="health_changes" checkedItem={this.state.health_changes} onchange={this.onShowQuestion} />

			                        	<RadioButton name="questionnaires[health_changes][choices]" id="healthRadio" label="Yes" index="1" value="yes" selectedState="health_changes" checkedItem={this.state.health_changes} onchange={this.onShowQuestion}  />

	                                    <div className="form-group form-md-line-input" style={{display : this.state.displayHealthChanges}}>
							                <input type="text" placeholder="" name="questionnaires[health_changes][question]" className="form-control" value={this.state.health_changes_question} onBlur={this.onInputField} onChange={(e) => {this.setState({health_changes_question : e.target.value})}} />
											<label className="control-label">if yes, explain</label>
						                </div>
                                    </div>
								</li>
								<li>
									<p>
				                        Have you ever been hospitalized?
				                    </p>
			                        <div className="md-radio-inline" style={{marginBottom: '20px'}}>

			                        	<RadioButton name="questionnaires[hospitalized][choices]" id="hostRadio" label="No" index="0" value="no" selectedState="hospitalized" checkedItem={this.state.hospitalized} onchange={this.onShowQuestion} />
			                        	
			                        	<RadioButton name="questionnaires[hospitalized][choices]" id="hostRadio" label="Yes" index="1" value="yes" selectedState="hospitalized" checkedItem={this.state.hospitalized} onchange={this.onShowQuestion} />
                                        
                                        <div className="form-group form-md-line-input" style={{display : this.state.displayHospitalized}}>
							                <input type="text" placeholder="" name="questionnaires[hospitalized][question]" className="form-control" value={this.state.hospitalized_question} onBlur={this.onInputField} onChange={(e) => {this.setState({hospitalized_question : e.target.value})}} />
											<label className="control-label">if yes, for what reason?</label>
						                </div>
                                    </div>
								</li>
								<li>
									<p>
				                        Have you or are you taking any of the following medications or injections?
				                    </p>
				                    <div className="row">
				                    	<div className="col-sm-4 col-md-offset-8 col-xs-offset-6 col-xs-6 text-center">
				                            <div className="col-sm-6 col-xs-6">
				                                Yes
				                            </div>
				                            <div className="col-sm-6 col-xs-6">
				                                No
				                            </div>
				                        </div>
				                    </div>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Aspirin,Tylenol, Motrin
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[aspirin]" id="aspirinRadio" label="" index="0" value="yes" selectedState="aspirin" checkedItem={this.state.aspirin} onchange={this.onInputField} />

	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[aspirin]" id="aspirinRadio" label="" index="1" value="no" selectedState="aspirin" checkedItem={this.state.aspirin} onchange={this.onInputField} />

	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Anticoagulants (blood thinners, Cournadin, etc.)
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[anticoagulants]" id="antiRadio" label="" index="0" value="yes" selectedState="anticoagulants" checkedItem={this.state.anticoagulants} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[anticoagulants]" id="antiRadio" label="" index="1" value="no" selectedState="anticoagulants" checkedItem={this.state.anticoagulants} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Heart Medication (Nitroglycerin, etc.)
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[heart_medication]" id="heartMedRadio" label="" index="0" value="yes" selectedState="heart_medication" checkedItem={this.state.heart_medication} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[heart_medication]" id="heartMedRadio" label="" index="1" value="no" selectedState="heart_medication" checkedItem={this.state.heart_medication} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Antibiotics (penicillin, Tetracycline, Erythromycin, etc.)
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[antibiotics]" id="antibioticsRadio" label="" index="0" value="yes" selectedState="antibiotics" checkedItem={this.state.antibiotics} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[antibiotics]" id="antibioticsRadio" label="" index="1" value="no" selectedState="antibiotics" checkedItem={this.state.antibiotics} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Steroids (Cortisone, Prednisone, etc.)
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[steroids]" id="steroidsRadio" label="" index="0" value="yes" selectedState="steroids" checkedItem={this.state.steroids} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[steroids]" id="steroidsRadio" label="" index="1" value="no" selectedState="steroids" checkedItem={this.state.steroids} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Diabetes Medication (Insulin, Orinase, etc.)
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[diabetes]" id="diabetesRadio" label="" index="0" value="yes" selectedState="diabetes" checkedItem={this.state.diabetes} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[diabetes]" id="diabetesRadio" label="" index="1" value="no" selectedState="diabetes" checkedItem={this.state.diabetes} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Narcotics (Codeine, Percodan, Methadone, etc.)
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[narcotics]" id="narcoRadio" label="" index="0" value="yes" selectedState="narcotics" checkedItem={this.state.narcotics} onchange={this.onInputField} />

	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[narcotics]" id="narcoRadio" label="" index="1" value="no" selectedState="narcotics" checkedItem={this.state.narcotics} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Tranquilizers or sleeping pills (Valium, etc)
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[tranquilizers]" id="tranqRadio" label="" index="0" value="yes" selectedState="tranquilizers" checkedItem={this.state.tranquilizers} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[tranquilizers]" id="tranqRadio" label="" index="1" value="no" selectedState="tranquilizers" checkedItem={this.state.tranquilizers} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row">
				                        <div className="col-sm-8 col-xs-6">
				                            Birth Control Pills or Hormonal Therapy
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[birth_control]" id="birthRadio" label="" index="0" value="yes" selectedState="birth_control" checkedItem={this.state.birth_control} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[birth_control]" id="birthRadio" label="" index="1" value="no" selectedState="birth_control" checkedItem={this.state.birth_control} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
				                    <br/>
				                    <div className="row" style={{marginBottom: '20px'}}>
				                        <div className="col-sm-8 col-xs-6">
				                            Recreational Drugs (Cocaine, Marijuana, etc.)
				                        </div>
				                        <div className="col-sm-4 col-xs-6 text-center">
				                            <div className="md-radio-inline">
				                            	<div className="col-md-6 col-xs-6">

				                            		<RadioButton name="questionnaires[recreational]" id="recreationalRadio" label="" index="0" value="yes" selectedState="recreational" checkedItem={this.state.recreational} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                            <div className="col-md-6 col-xs-6">

	                                            	<RadioButton name="questionnaires[recreational]" id="recreationalRadio" label="" index="1" value="no" selectedState="recreational" checkedItem={this.state.recreational} onchange={this.onInputField} />
		                                            
	                                            </div>
	                                        </div>
				                        </div>
				                    </div>
								</li>
								<li>
									<p>
				                        Do you have or have you had any of the following? Indicate with a check.
				                    </p>
				                    <div className="row" style={{marginBottom: '20px'}}>
				                    	<div className="col-md-4">
				                    		{this.state.checkboxItem.map((item, i) => {
				                    			if(i < 11) {
				                    				return <Checkbox {...item} key={i} index={i} onchange={this.onInputField} checkedItems={this.state.sickness} />
				                    			}
				                    		})}
				                    	</div>
				                    	<div className="col-md-4">
				                    		{this.state.checkboxItem.map((item, i) => {
				                    			if(i > 10 && i < 22) {
				                    				return <Checkbox {...item} key={i} index={i} onchange={this.onInputField} checkedItems={this.state.sickness} />
				                    			}
				                    		})}
				                    	</div>
				                    	<div className="col-md-4">
				                    		{this.state.checkboxItem.map((item, i) => {
				                    			if(i > 21) {
				                    				return <Checkbox {...item} key={i} index={i} onchange={this.onInputField} checkedItems={this.state.sickness} />
				                    			}
				                    		})}
				                    	</div>
				                    </div>
								</li>
								<li>
									<p>
										Has anyone in your family had any of the following?
									</p>
									<div className="row" style={{marginBottom: '20px'}}>
										<div className="col-sm-12">
											{this.state.checkboxItem2.map((item, i) => {
				                    			return <Checkbox {...item} key={i} index={i} onchange={this.onInputField} checkedItems={this.state.family_sickness} />
				                    		})}
										</div>
									</div>
								</li>
								<li>
									<p>
										Do you smoke?
									</p>
									<div className="row" style={{marginBottom: '20px'}}>
										<div className="col-md-12">
											<div className="md-radio-inline">

												<RadioButton name="questionnaires[smoking]" id="smokeRadio" label="No" index="0" value="no" selectedState="smoking" checkedItem={this.state.smoking} onchange={this.onInputField} />
	                                            
	                                            <RadioButton name="questionnaires[smoking]" id="smokeRadio" label="Yes" index="1" value="yes" selectedState="smoking" checkedItem={this.state.smoking} onchange={this.onInputField} />
	                                            
	                                        </div>
										</div>
									</div>
								</li>
								<li>
									<p style={{margin: 0}}>
										Other Sickness
									</p>
									<div className="form-group">
										<div className="row">
											<div className="col-md-12">
												<div className="form-group form-md-line-input">
									                <input type="text" placeholder="" name="questionnaires[patient_other_sickness]" className="form-control" value={this.state.patient_other_sickness} onBlur={this.onInputField} onChange={(e) => { this.setState({patient_other_sickness : e.target.value}) }} />
													<label className="control-label">&nbsp;</label>
								                </div>
											</div>
										</div>
									</div>
								</li>
							</ol>
						</div>
					</div>
				</div>
			</form>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Medical_history/MedicalHistory.js
 **/